module.exports = __webpack_public_path__ + "static/media/Control Cables.824c3ad3.png";